import React, { useState, useEffect } from 'react';
import { Box, Button, Typography } from "@mui/material";
import { ArrowLeft, RefreshCw } from "lucide-react";

interface FileNavigationProps {
  currentPath: string[];
  isDarkMode?: boolean;
  isRefreshing?: boolean;
  onNavigateRoot: () => void;
  onNavigateBack: () => void;
  onNavigateTo: (index: number) => void;
  onManualRefresh?: () => void;
  truncateFileName?: (fileName: string, maxLength?: number) => string;
}

export const FileNavigation: React.FC<FileNavigationProps> = ({
  currentPath,
  isDarkMode = true,
  isRefreshing = false,
  onNavigateRoot,
  onNavigateBack,
  onNavigateTo,
  onManualRefresh,
  truncateFileName = (name) => name,
}) => {
  
  const [textConfig, setTextConfig] = useState<any>({});

  const fetchTextConfig = async () => {
    try {
      const response = await fetch("/text.json");
      const data = await response.json();
      setTextConfig(data);
    } catch (error) {
      console.error("Error loading text config:", error);
    }
  };

  useEffect(() => {
    fetchTextConfig();
  }, []);

  return (
    <>
      <Box 
        display="flex" 
        alignItems="center" 
        justifyContent="space-between" 
        mb={2}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Button
            variant="text"
            onClick={onNavigateRoot}
            sx={{ color: isDarkMode ? "#fff" : "#000" }}
          >
            {textConfig.FILE_NAVIGATION_ROOT}
          </Button>
          {currentPath.map((folder, index) => (
            <React.Fragment key={folder}>
              <Typography color={isDarkMode ? "white" : "black"}>/</Typography>
              <Button
                variant="text"
                onClick={() => onNavigateTo(index)}
                sx={{ color: isDarkMode ? "#fff" : "#000" }}
              >
                {truncateFileName(folder)}
              </Button>
            </React.Fragment>
          ))}
        </Box>

        {onManualRefresh && (
          <Button
            onClick={onManualRefresh}
            disabled={isRefreshing}
            variant="contained"
            startIcon={
              <RefreshCw
                size={16}
                className={isRefreshing ? "animate-spin" : ""}
              />
            }
            sx={{
              backgroundColor: "#1BCF66",
              color: "white",
              borderRadius: "8px",
              px: 2,
              py: 1,
              textTransform: "none",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "#1BCF66",
                opacity: 0.9,
              },
              "&:disabled": {
                backgroundColor: "#666",
                color: "#999",
              },
            }}
            title={textConfig.FILE_NAVIGATION_REFRESH_TITLE || "Actualizar"}
          >
            {textConfig.FILE_NAVIGATION_REFRESH_BUTTON || "Actualizar"}
          </Button>
        )}
      </Box>

      {currentPath.length > 0 && (
        <Button
          onClick={onNavigateBack}
          startIcon={<ArrowLeft />}
          sx={{ 
            mb: 2,
            color: isDarkMode ? "#fff" : "#000",
            borderColor: isDarkMode ? "#404040" : "#e5e7eb",
          }}
          variant="outlined"
        >
          {textConfig.FILE_NAVIGATION_BACK}
        </Button>
      )}
    </>
  );
};